let moment: any = require("moment")

import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms';

export class ValidationService {
	private static BACKEND_DATE_FORMAT: string = "YYYY-MM-DDTHH:mm:ss";

	static getValidatorErrorMessage(code: string) {
		let config = {
			'required': 'Pflichtfeld',
			'invalidTitle': 'Titel ist falsch',
			'endBeforeEqualToBegin': 'Beginn muss vor dem Ende sein.',
			'tooManySeats': 'Es wurden zuviele verkaufbare Sitze ausgewählt.',
			'invalidPositiveInteger': 'Das Feld darf nur positive ganze Zahlen enthalten',
			'onlyWhitespace': 'Das Feld darf nicht nur Leerzeichen enthalten',
			'noWhitespace': 'Das Feld darf keine Leerzeichen enthalten',
			'ifOneValueThenAllValuesRequired': 'Bitte alle (oder keine) Felder ausfüllen',
			'invalidsponsorCode': 'Das Feld darf Zahlen, Großbuchstaben ohne Umlaute und folgende Sonderzeichen enthalten: _ - ! & #',
			'invalidUpperCaseAndNumbers': 'Das Feld darf nur Großbuchstaben und Zahlen enthalten',
			'invalidFirstCharLetter': 'Das erste Zeichen muss ein Buchstabe sein',
			'mustBeLowerCase': 'Das Feld darf nur Kleinbuchstaben ohne Umlaute, Zahlen und folgende Sonderzeichen enthalten: _ -',
		};

		return config[code] || "Ihre Eingabe ist ungültig";
	}

	static endBeforeBeginDate(beginKey: string, endKey: string) {
		return (group: FormGroup): { [key: string]: any } => {
			let beginDate: String = group.controls[beginKey].value
			let endDate: String = group.controls[endKey].value

			if (beginDate == null || endDate == null) {
				return null
			}

			if (moment(endDate, this.BACKEND_DATE_FORMAT).isSameOrBefore(moment(beginDate, this.BACKEND_DATE_FORMAT))) {
				return {
					endBeforeEqualToBegin: true
				}
			}

			return null
		}
	}

	static positiveInteger(control: AbstractControl) {
		if (!control.value) {
			return null
		} else if (control.value.match(/^[0123456789]+$/)) {
			return null
		} else {
			return {'invalidPositiveInteger': true}
		}
	}

	static max(max: number): ValidatorFn {
		return (control: FormControl): { [key: string]: boolean } | null => {
			let val: number = control.value
			if (control.pristine || control.pristine) {
				return null
			}
			if (val <= max) {
				return null
			}
			return {'max': true}
		}
	}

	static min(min: number): ValidatorFn {
		return (control: FormControl): { [key: string]: boolean } | null => {
			let val: number = control.value
			if (control.pristine || control.pristine) {
				return null
			}
			if (val >= min) {
				return null
			}
			return {'min': true}
		}
	}

	static ifOneValueThenAllValuesRequired(...controlKeys: any[]) {
		return (group: FormGroup): { [key: string]: any } => {
			let valid = false
			let atLeastOneHasValue, atLeastOneHasNoValue

			controlKeys.forEach(key => {
				if (group.controls[key].value && group.controls[key].value.toString().trim().length > 0) {
					atLeastOneHasValue = true
				}
				if (!group.controls[key].value || (group.controls[key].value && group.controls[key].value.toString().trim().length === 0)) {
					atLeastOneHasNoValue = true
				}
			});
			if (!atLeastOneHasValue || atLeastOneHasValue && !atLeastOneHasNoValue) {
				valid = true
			}
			if (valid) {
				return null
			}

			return {
				ifOneValueThenAllValuesRequired: true
			}
		}
	}

	static atLeastOneValue(...controlKeys: any[]) {
		return (group: FormGroup): { [key: string]: any } => {
			let valid = false
			controlKeys.forEach(key => {

				if (group.controls[key].value && group.controls[key].value.trim().length > 0) {
					valid = true;
				}
			});

			if (valid) {
				return null
			}

			return {
				atLeastOneValue: true
			}
		}
	}

	static atLeastOneValueOfCheckboxGroup(formGroup: FormGroup) {
		let valid = false
		for (let key in formGroup.controls) {
			if (formGroup.controls[key].value) {
				valid = true;
			}
		}
		if (valid) {
			return null;
		}
		return {
			atLeastOneValue: true
		}
	}

	static notOnlyWhitespace(control: AbstractControl) {
		if (!control.value || (control.value && control.value.trim().length > 0)) {
			return null
		}
		return {
			'onlyWhitespace': true
		}
	}

	static noWhitespace(control: AbstractControl) {
		if (!control.value || (control.value && control.value.replace(/\s/g, "").length === control.value.length)) {
			return null
		}
		return {
			'noWhitespace': true
		}
	}

	static validEmail(control: AbstractControl) {
		if (!control.value || control.value.trim().length === 0) {
			return null
		}
		// check format of email to be like: "someSigns@someSigns.someSigns"
		if (control.value.match(/\S+@\S+\.\S+/)) {
			return null;
		}
		return {
			'invalidEmail': true
		}
	}

	static sponsorCode(control: AbstractControl) {
		if (!control.value || control.value.trim().length === 0) {
			return null
		}
		if (control.value.match(/^[A-Z0-9_\-!&#]*$/)) {
			return null;
		}
		return {
			'invalidsponsorCode': true
		}
	}

	static firstCharLetter(control: AbstractControl) {
		if (!control.value || control.value.trim().length === 0) {
			return null
		}
		if (control.value.match(/^[A-Za-z][\S]*$/)) {
			return null;
		}
		return {
			'invalidFirstCharLetter': true
		}
	}

	static onlyLowerCase(control: AbstractControl) {
		if (!control.value || control.value.trim().length === 0) {
			return null
		}
		if (control.value.match(/^[a-z0-9_\-]*$/)) {
			return null;
		}
		return {
			'mustBeLowerCase': true
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/services/validation.service.ts